<template>
  <Proposals
    :product-id="productID"
    :statuses="statuses"
    :steps="new Set([
      'upload',
      'basic',
      'documents',
      'address',
      'bank',
      'proposal-data',
    ])"
    :title="meta.title"
  >
    <ModalCreditor
      v-if="!loading && modal.creditor"
      @close="close({ key: 'creditor' })"
    />
    <ModalSurveyAccordance
      v-if="!loading && modal.survey"
      @close="close({ key: 'survey' })"
    />
  </Proposals>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import config from '@/data/config';
import roleManagerMixin from '@/mixins/roleManager.mixin';
import seo from '@/utils/seo';

import Proposals from '@/layouts/ProposalsList.vue';
import ModalCreditor from '@/components/ModalCreditor.vue';
import ModalSurveyAccordance from '@/components/ModalSurveyAccordance.vue';

export default {
  name: 'FGTSList',
  components: {
    Proposals,
    ModalCreditor,
    ModalSurveyAccordance,
  },
  mixins: [
    roleManagerMixin,
  ],
  provide() {
    return {
      productID: this.productID,
    };
  },
  data: () => ({
    meta: {
      title: 'Propostas FGTS',
    },
    productID: config.PRODUCT_ID_FGTS,
    modal: {
      survey: true,
      creditor: true,
    },
  }),
  computed: {
    ...mapState({
      user: (state) => state.user.userInfo,
      loading: (state) => state.app.loading,
      show_survey_commissions: (state) => state.app.show_survey_commissions,
      statuses: (state) => state.app.statuses,
    }),
  },
  watch: {
    show_survey_commissions: {
      immediate: true,
      handler(value) {
        if (value === false) {
          this.modal.survey = false;
        }
      },
    },
  },
  created() {
    this.modal.creditor = this.isCreditor;
  },
  async mounted() {
    await this.getSuppliersList(this.productID);
  },
  methods: {
    ...mapActions({
      getSuppliersList: 'app/SET_SUPPLIERS',
    }),
    close({ key }) {
      this.modal[key] = false;
    },
  },
  metaInfo() {
    return seo.meta(this.meta);
  },
};
</script>
